import { useEffect, useState } from 'react';
import { RoleUserOrgAssociationDto } from '@/apiClient';
import { PrivateContextData } from '@/components/private/PrivateContext';
import { SELECTED_ORG_ID } from '@/configs/storageKeys';

export const usePrivateContextState = () => {
  const [userOrganisations, setUserOrganisations] = useState<
    RoleUserOrgAssociationDto[]
  >([]);
  const [selectedOrganisation, setSelectedOrganisation] = useState<
    RoleUserOrgAssociationDto | undefined
  >(undefined);
  const [selectedOrganisationId, setSelectedOrganisationId] = useState(
    Number(window.sessionStorage.getItem(SELECTED_ORG_ID)) || undefined,
  );
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [contextData, setContextData] = useState<PrivateContextData>({});

  useEffect(() => {
    setContextData((prev) => ({
      ...prev,
      selectedOrganisation,
      setSelectedOrganisation,
      selectedOrganisationId,
      setSelectedOrganisationId,
      userOrganisations,
      setUserOrganisations,
      showSplashScreen,
      setShowSplashScreen,
    }));
  }, [
    selectedOrganisation,
    selectedOrganisationId,
    userOrganisations,
    showSplashScreen,
  ]);

  return {
    userOrganisations,
    setUserOrganisations,
    selectedOrganisation,
    setSelectedOrganisation,
    selectedOrganisationId,
    setSelectedOrganisationId,
    showSplashScreen,
    setShowSplashScreen,
    contextData,
    setContextData,
  };
};
